import { ApolloClient } from '@apollo/client'
import createFetchSaga from '@utils/store/createFetchSaga'
import { sagaDebounce } from '@store/helpers'
import { actionTypes } from './index'
import reservationInternalStockChangesGetQuery from '@queries/reservationInternalStockChangesGetQuery'

const fetchList = async (client: ApolloClient<any>, action: Action): Promise<any> => {
  return await client
    .query({ query: reservationInternalStockChangesGetQuery, variables: action.payload })
    .then(({ data }) => ({ data: data?.reservationInternalStockChangesGet }))
}

export default function* watch(): Generator {
  if (typeof window === 'undefined') return
  yield sagaDebounce(200, actionTypes.run, createFetchSaga(actionTypes.run, fetchList))
}
